import $ from "jquery";

const megaMenuHeader = () => {
  const init = () => {
    setMenuViewActive();

    $(() => {
      bindEvents();
    });
  };

  const bindEvents = () => {
    $(window).on("resize load", handleResizeLoad);
    $(".mi-mega-menu_list .mi-mega-menu_list-item a").on("click", function () {
      toggleMenuItem($(this));
    });
    $(document).on("click", ".js-menu-header-tab", toggleMegaMenuMobile);
    $(document).on("click", ".js-close-mega-menu", closeMegaMenuMobile);
    $(window).on("scroll", debounce(handleScroll, 16));
  };

  $(document).on("click", function (event) {
    const $megaMenu = $(".js-mi-mega-menu");
    const $target = $(event.target);

    if (
      !$megaMenu.is($target) &&
      $megaMenu.has($target).length === 0 &&
      !$target.closest(".js-menu-header-tab").length
    ) {
      $megaMenu.removeClass("active");
      $(".mi-mega-menu_list-item").removeClass("active");
    }
  });

  $(document).on(
    "click",
    ".js-mi-mega-menu_list .mi-mega-menu_list-item.has-children",
    function () {
      const header = $(".mi-Header");

      if (header.hasClass("mi-Header_active")) {
        header.removeClass("mi-Header_active");
      } else {
        header.addClass("mi-Header_active");
      }
    }
  );

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".js-mi-mega-menu_list, .mi-Header").length) {
      $(".mi-Header").removeClass("mi-Header_active");
    }
  });

  const handleResizeLoad = () => {
    const megamenuSelector = ".js-mi-mega-menu";
    const listMenuSelector =
      ".js-mi-mega-menu_list .mi-mega-menu_list-item.has-children";
    const listMenu = $(listMenuSelector);

    $(".elementor-sticky__spacer").find(listMenuSelector).removeClass("active");

    // const isActive = $(listMenu[0]).hasClass("active");
    const windowWidth = $(window).outerWidth();

    if (windowWidth < 1025 && !isActive) {
      $(listMenu[0]).addClass("active");
      toggleMenuItem($(listMenu[0]));
    }

    if (windowWidth > 1024) {
      console.log($(megamenuSelector).find("active"));

      adjustMegaMenuPos($(listMenu[0]));

      $(megamenuSelector)
        .find(".active")
        .each(function () {
          const transition = $(this).css("transition");
          $(this).css({
            transition: "none",
          });

          $(this).removeClass("active");

          setTimeout(() => {
            $(this).css({
              transition: transition,
            });
          }, 301);
        });
    }
  };

  const adjustMegaMenuPos = ($this) => {
    const windowWidth = $(window).outerWidth();

    $this
      .closest(".js-mi-mega-menu")
      .find(".mi-mega-menu_list-item-content")
      .css({
        left:
          windowWidth >= 1025
            ? -1 * $(".mi-mega-menu_list-item.has-children").offset().left
            : "0px",
      });
  };

  const toggleMenuItem = function ($this) {
    const parentItem = $this.parent();

    adjustMegaMenuPos($this);

    parentItem.toggleClass("active");

    if (parentItem.hasClass("active"))
      parentItem.closest("section").toggleClass("header-effect-active");
  };

  const toggleMegaMenuMobile = function () {
    const section = $(this).closest("section");
    // const listMenu = section.find(
    //   ".js-mi-mega-menu_list .mi-mega-menu_list-item.has-children"
    // );

    if (!section.find(".js-mi-mega-menu").hasClass("active")) {
      section.find(".js-mi-mega-menu").addClass("active");
    }

    // if (!$(listMenu[0]).hasClass("active")) {
    //   $(listMenu[0]).addClass("active");
    // }
  };

  const closeMegaMenuMobile = function () {
    const section = $(this).closest("section");
    section.find(".js-mi-mega-menu").removeClass("active");
  };

  const handleScroll = () => {
    // $(window).on("scroll", function () {
    //   const listMenu = $(
    //     ".js-mi-mega-menu_list .mi-mega-menu_list-item.has-children"
    //   );
    //   // const scrollPosition = $(window).scrollTop();
    //   const windowWidth = $(window).width();

    //   if (windowWidth >= 1025 && listMenu.hasClass("active")) {
    //     $(listMenu).removeClass("active");
    //     $(listMenu).closest("section").removeClass("elementor-sticky--effects");
    //   }
    // });

    const headerEl = $(".mi-Header");
    const scrollTop = $(window).scrollTop();

    headerEl.toggleClass("header-effect-active", scrollTop > 0);
  };

  const debounce = (func, timeout = 300) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), timeout);
    };
  };

  const setMenuViewActive = () => {
    $(".mi-mega-menu_list")
      .find(".mi-mega-menu_list-item > a")
      .each(function () {
        const href = $(this).attr("href") || $(this).attr("data-href") || "";

        if (href.length) {
          const url = new URL(href);
          const currUrl = new URL(window.location.href);
          const isShop =
            url.pathname.includes("shop") || url.pathname.includes("producten");

          if (currUrl.pathname.includes(url.pathname)) {
            $(this).closest(".mi-mega-menu_list-item").addClass("active");

            if (isShop) {
              $(this).attr("style", "color: #d5b895 !important");
            }
          }
        }
      });
  };

  init();
};

try {
  megaMenuHeader();
} catch (error) {
  console.error(error);
}
